export const DIVORCES_ON_DELETE_REQUESTED = 'DIVORCES_ON_DELETE_REQUESTED';
export const DIVORCES_ON_DELETE_SUCCEEDED = 'DIVORCES_ON_DELETE_SUCCEEDED';
export const DIVORCES_ON_DELETE_FAILED = 'DIVORCES_ON_DELETE_FAILED';

export const DIVORCES_ON_DELETE_FILE_REQUESTED = 'DIVORCES_ON_DELETE_FILE_REQUESTED';
export const DIVORCES_ON_DELETE_FILE_SUCCEEDED = 'DIVORCES_ON_DELETE_FILE_SUCCEEDED';
export const DIVORCES_ON_DELETE_FILE_FAILED = 'DIVORCES_ON_DELETE_FILE_FAILED';

export const DIVORCES_ON_GET_ALL_REQUESTED = 'DIVORCES_ON_GET_ALL_REQUESTED';
export const DIVORCES_ON_GET_ALL_SUCCEEDED = 'DIVORCES_ON_GET_ALL_SUCCEEDED';
export const DIVORCES_ON_GET_ALL_FAILED = 'DIVORCES_ON_GET_ALL_FAILED';

export const DIVORCES_ON_GET_FORM_REQUESTED = 'DIVORCES_ON_GET_FORM_REQUESTED';
export const DIVORCES_ON_GET_FORM_SUCCEEDED = 'DIVORCES_ON_GET_FORM_SUCCEEDED';
export const DIVORCES_ON_GET_FORM_FAILED = 'DIVORCES_ON_GET_FORM_FAILED';

export const DIVORCES_ON_GET_ONE_REQUESTED = 'DIVORCES_ON_GET_ONE_REQUESTED';
export const DIVORCES_ON_GET_ONE_SUCCEEDED = 'DIVORCES_ON_GET_ONE_SUCCEEDED';
export const DIVORCES_ON_GET_ONE_FAILED = 'DIVORCES_ON_GET_ONE_FAILED';

export const DIVORCES_ON_SAVE_REQUESTED = 'DIVORCES_ON_SAVE_REQUESTED';
export const DIVORCES_ON_SAVE_SUCCEEDED = 'DIVORCES_ON_SAVE_SUCCEEDED';
export const DIVORCES_ON_SAVE_FAILED = 'DIVORCES_ON_SAVE_FAILED';
